const nifAndorraParticularRegEx = /^[EF]\d{6}[A-Z]$/i;
const nifAndorraEntityRegEx = /^[A-Z]\d{6}[A-Z]$/i;

const dniRegEx = /^(\d{8})[TRWAGMYFPDXBNJZSQVHLCKE]$/;
const nieRegEx = /^[XYZxyz](\d{7})[TRWAGMYFPDXBNJZSQVHLCKE]$/;

const passportRegEx = /(^[A-Z]{3})(\d{6})[A-Z]?$/;
const cifRegEx = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;

const regexFrenchNIF = /^(\d{4}\s?\d{3}\s?\d{3})$/;
const regexFrenchSIREN = /^(\d{3}\s?\d{3}\s?\d{3})$/;

const test = (regEx, value) => regEx.test(value.toUpperCase());

const cleanDocument = (document) => document.replace(/\s/g, "").toUpperCase();

const isDNI = (documentNumber) => test(dniRegEx, documentNumber);

const isNIE = (documentNumber) => test(nieRegEx, documentNumber);

const isPassport = (documentNumber) => test(passportRegEx, documentNumber);

const isCIF = (documentNumber) => test(cifRegEx, documentNumber);

const validateDNILetter = (dni) => {
  const letters = [
    "T",
    "R",
    "W",
    "A",
    "G",
    "M",
    "Y",
    "F",
    "P",
    "D",
    "X",
    "B",
    "N",
    "J",
    "Z",
    "S",
    "Q",
    "V",
    "H",
    "L",
    "C",
    "K",
    "E",
  ];

  const dniNumber = parseInt(dni.replace(/\D/g, ""), 10);
  const dniLetter = dni.replace(/[^A-Z]+/g, "").toUpperCase();

  const rest = dniNumber % 23;
  const letterMustBe = letters[rest] || false;

  return dniLetter === letterMustBe;
};
const validateNIELetter = (nie) => {
  nie = nie.replace(/[XYZ]/gi, (match) => {
    return { X: "0", Y: "1", Z: "2" }[match];
  });

  return validateDNI(nie);
};

const validateSpanishDocument = (document) => {
  return (
    (isDNI(document) && validateDNILetter(document)) ||
    (isNIE(document) && validateNIELetter(document)) ||
    isPassport(document) ||
    isCIF(document)
  );
};

const validateAndorraDocument = (document) => {
  return (
    test(nifAndorraParticularRegEx, document) ||
    test(nifAndorraEntityRegEx, document)
  );
};

const validateBaggeteDocument = (document) => {
  return test(regexFrenchNIF, document) || test(regexFrenchSIREN, document);
};

const validateDocument = (document) => {
  document = cleanDocument(document);
  return (
    validateAndorraDocument(document) ||
    validateSpanishDocument(document) ||
    validateBaggeteDocument(document)
  );
};
export default {
  validateDocument,
};
